import { Accordion } from '@iwoca/orion';

import TelephoneIcon from '../../../components/svg/TelephoneIcon.svg?react';
import constants from '../../../constants.json';
import { TEnabledOptions } from '../../hooks/useEnabledTerms';

const panelListClass =
  'list-none p-l pb-0 bg-white text-s rounded-xs text-primary-10 mt-0';

export const HelpTextAccordion = ({
  enabledOptions = ['THREE_MONTHS', 'TWELVE_MONTHS', 'PAY_NOW'],
  className,
}: {
  enabledOptions?: TEnabledOptions;
  className?: string;
}) => {
  return (
    <div className={className}>
      {enabledOptions.includes('PAY_NOW') && (
        <Accordion title="How Pay Now works" small>
          <ol className={panelListClass}>
            <ListItem header="Select your bank">
              You'll log into your online banking either on mobile or desktop
            </ListItem>
            <ListItem header="Agree to a Bank Transfer">
              You won't need to fill anything out, simply confirm the details
            </ListItem>
            <ListItem header="Confirmation">
              You'll see confirmation of your payment today
            </ListItem>
          </ol>
        </Accordion>
      )}
      {(enabledOptions.includes('THREE_MONTHS') ||
        enabledOptions.includes('TWELVE_MONTHS')) && (
        <Accordion title="How Pay Later works" small>
          <ol className={panelListClass}>
            <ListItem header="Tell us about your business">
              You'll only need to do this the first time you use iwocaPay
            </ListItem>
            <ListItem header="See your payment plan">
              You can pay earlier any time (for free) to save on interest
            </ListItem>
            <ListItem header="Secure your account">
              You'll need your passport or driver's licence to confirm your
              identity
            </ListItem>
            <ListItem header="You pay later">
              Your supplier gets paid up front
            </ListItem>
          </ol>
        </Accordion>
      )}
      <Accordion title="Contact" small>
        <ol className={panelListClass}>
          <ListItem header="Need help checking out?">
            <a
              href={constants.iwocapayTelLink}
              className="flex items-center font-med text-inherit no-underline"
            >
              <TelephoneIcon className="mx-xs w-[14px] fill-primary-40" />
              {constants.iwocapayTelDisplay}
            </a>
            <a
              href="https://www.iwoca.co.uk/iwocapay-buyer-pay-later"
              target="_blank"
              rel="noopener noreferrer"
              className="text-s text-primary-40"
            >
              Find out more about iwocaPay
            </a>
          </ListItem>
          <ListItem header="Want to check the details?">
            We got them directly from your supplier &mdash; get in touch with
            them to double check
          </ListItem>
        </ol>
      </Accordion>
    </div>
  );
};

const ListItem = ({
  header,
  children,
}: {
  header: string;
  children: React.ReactNode;
}) => (
  <li>
    <div className="font-bold">{header}</div>
    <div className="pb-xl pt-s font-reg">{children}</div>
  </li>
);
